import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { OrganisationService } from 'app/core/organisation/organisation.service';
import { IRole, Organisation, OrganisationBasic } from 'app/core/organisation/organisation.types';
import { Observable, window } from 'rxjs';
import { Router } from '@angular/router';
import { OrganisationNameComponent, OrganisationNameSize } from '../organisation-name/organisation-name.component';

import { UserService } from 'app/core/user/user.service';
import { user } from 'app/mock-api/common/user/data';
@Component({
    selector: 'organisation-switcher',
    templateUrl: './organisation-switcher.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatDividerModule,
        OrganisationNameComponent
    ],
})
export class OrganisationSwitcherComponent implements OnInit {
    readonly OrganisationNameSize = OrganisationNameSize;
    organisations$: Observable<Organisation[]>;
    organisations: Organisation[] = [];
    currentOrganisation$: Observable<Organisation | null>;
    organisation: Organisation | null = null;
    userRole: IRole | null = null;
    constructor(
        private _organisationService: OrganisationService,
        private _router: Router,
        private _userService: UserService
    ) {
        this.organisations$ = this._organisationService.organisations$;
        this.currentOrganisation$ = this._organisationService.currentOrganisation$ as Observable<Organisation>;
        this.currentOrganisation$.subscribe((organisation) => {
            this._userService.userRole$.subscribe((userRole) => {
                this.userRole = userRole;
                this.organisation = organisation;
            });
        });

        this.organisations$.subscribe((organisations) => {
            this.organisations = organisations;
        });
    }

    ngOnInit(): void {}

    /**
     * Switch organization
     */
    switchOrganisation(organisation: OrganisationBasic): void {
        // const url = this._router.url.replace(`/${this.organisation.slug}`, '');
        // this._organisationService.switchOrganisation(organisation, url);
        this._organisationService.switchOrganisation(organisation, '/proposals');
    }

    /**
     * Create new organization
     */
    createNewOrganisation(): void {
        // check current url is 

        const currentUrl = this._router.url;
        // check if currentURL is deeper than 2 levels and
        // if so, go back to the previous level before going to /user/settings/profile
        let urlParts = currentUrl.split('/');
        // remove the empaty string from the array
        urlParts = urlParts.filter(part => part !== '');
        if (urlParts.length > 2) {
            // go back to the previous level
            this._router.navigate([urlParts[0], urlParts[1]]).then(() => {
                this._router.navigate(['/create-organisation']);
            });
            
        } else {
            this._router.navigate(['/create-organisation']);
        }
    }

    /**
     * Navigate to settings
     */
    gotoSettings(section: string): void {
        this._router.navigate([`/${this.organisation.slug}/settings`]);
    }
} 